<div class="entities-progress-contaner">
  <app-progressbar class="app-progressbar" [progress]="75"></app-progressbar>
  <div class="title">
    {{
      "Despliega para ver más detalles de los bancos que has añadido"
        | translate
    }}
  </div>
  <div class="info-banner" *ngIf="hasAllErrors()">
    <img src="../../../assets/images/Info icon.png" width="24px" />
    <span>{{
      "No es posible añadir los bancos seleccionados" | translate
    }}</span>
  </div>
  <div class="entities">
    <app-spinner class="w-full py-4" *ngIf="!agregatedEntities"></app-spinner>
    <div
      class="entitie-container"
      *ngIf="agregatedEntities && agregatedEntities.length > 0"
    >
      <ng-container *ngFor="let entitie of agregatedEntities; let i = index">
        <div class="entitie" (click)="toggleSlideState(i)">
          <span class="name">{{ entitie.name }}</span>
          <div class="status">
            <div
              *ngIf="entitie.status !== 'loading'"
              [ngClass]="
                entitie.status &&
                ['error', 'KO', 'NON_OWNER_ACCOUNT'].includes(entitie.status)
                  ? 'tag error'
                  : 'tag'
              "
            >
              <!-- Error Cases -->
              <span *ngIf="entitie.status === 'error'">{{
                "Error" | translate
              }}</span>
              <span *ngIf="entitie.status === 'KO'">{{
                "TITULARITYERROR.TITLE" | translate
              }}</span>
              <span *ngIf="entitie.status === 'NON_OWNER_ACCOUNT'">{{
                "TITULARITYERROR.TITLE" | translate
              }}</span>
              <!-- Success Cases  -->
              <span
                *ngIf="entitie.status === 'success' || entitie.status === 'OK'"
                >{{ "COMPLETED" | translate }}</span
              >
              <span *ngIf="entitie.status === 'oncourse'">{{
                "ONCOURSE" | translate
              }}</span>
              <span *ngIf="entitie.status === 'VALIDATING'">{{
                "VALIDATINGTITULARITY" | translate
              }}</span>
            </div>
            <img
              *ngIf="entitie.status === 'loading'"
              src="../../../assets/images/loading-provisional.svg"
            />
            <img
              class="chevron"
              width="24px"
              [ngStyle]="{
                transform:
                  selectedSlide === i ? 'rotate(180deg)' : 'rotate(0deg)'
              }"
              src="../../../assets/icons/Chevron-drop.svg"
            />
            <san-icon
              iconcontent="trash-bin"
              color="#CC0000"
              class="trash-icon"
              (click)="openDeleteModal(entitie); $event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            ></san-icon>
          </div>
        </div>
        <app-slide
          [slideState]="
            selectedSlide === i ? SlideStates.OPEN : SlideStates.CLOSE
          "
        >
          <ng-container *ngFor="let account of entitie.accounts">
            <div class="progress-details">
              <div class="left">
                <span>{{ account.productName }}</span>
                <span>{{ account.iban }}</span>
              </div>
              <div class="right">
                <span>{{ "Saldo" | translate }}</span>
                <span>{{ account.balance }} {{ account.currency }}</span>
              </div>
            </div>
          </ng-container>
          <div *ngIf="entitie.status === 'success'" class="success-message">
            <img width="24px" src="../../../assets/icons/circle_tick.svg" />
            <span>{{ "Cuenta añadida" | translate }}</span>
          </div>
          <div *ngIf="entitie.status === 'error'" class="error-message">
            <div class="message-content">
            <img width="24px" src="../../../assets/images/Support icon.png" />
            <span>{{
              "No hemos podido conectar con el banco" | translate
            }}</span>
            </div>
             <san-ending-button
             (click)="retry(entitie.id!,i)"
             class="align-right"
             color="secondary"
             size="small"
             text="Reintentar"
             button-width="fit-content" 
             san-aria-label="Aria label text" 
             san-aria-description="Aria description text"
             (keydown)="$event.stopPropagation()"
             >
             </san-ending-button>
          </div>
         
        </app-slide>
      </ng-container>
    </div>
    <div
      *ngIf="agregatedEntities"
      class="add-entitie"
      (click)="navigateToEntities()"
    >
      <img width="24px" src="../../../assets/icons/Add.svg" />
      <span>{{ "Añadir mas bancos" | translate }}</span>
    </div>
  </div>
</div>
<san-modal
  [open]="isDeleteModalOpen"
  [backdrop]="true"
  [modalTitle]="deleteModalTitle"
  modalText="Dejarás de ver tus cuentas y movimientos de este banco. Podrás volver a agregarlo cuando quieras."
  iconType="trash-bin"
  iconColor="#CC0000"
  iconSize="size-48"
  contentAlign="center"
  titleAlign="center"
  [closeIcon]="true"
  [overlayClickClose]="true"
  (close)="closeDeleteModal()"
  (buttonClick)="onDeleteModalButtonClick($event)"
>
<div slot="additonal-content" class="modal-custom-footer">
    <san-ending-button color="secondary" text="Cancelar" (click)="closeDeleteModal()" (keydown)="$event.stopPropagation()"></san-ending-button>
    <san-ending-button color="primary" text="Eliminar" (click)="confirmDelete()" (keydown)="$event.stopPropagation()"></san-ending-button>
  </div>
</san-modal>

<app-ag-button-set
  [primaryLabel]="'Enviar solicitud'"
  [primaryDisabled]="
    hasAllErrors() || hasAnyLoadingOrInProgress() || !agregatedEntities || !canSubmitRequest()
  "
  [tertiaryLabel]="'Cancelar'"
  [backDisabled]="!agregatedEntities"
  (backButton)="navigateToEntities()"
  (continueButton)="continue()"
  (cancelButton)="cancel()"
></app-ag-button-set>

<san-toast class="toast-notification" *ngIf="isToastVisible" type="success" [showclose]="true" (close)="isToastVisible = false">
  <span slot="title">Agregación eliminada.</span>
  Has eliminado la agregación de {{ toastEntityName }}
</san-toast>

<san-toast class="toast-error-notification" *ngIf="isErrorToastVisible" type="error" [showclose]="true" (close)="isErrorToastVisible = false">
  Se ha producido un error al eliminar la agregación {{ toastEntityName }}
</san-toast>
